// Created by hejikun on 2017/10/25 0025.

let state = {
  adviser_msg_list: [], // 顾问消息列表
  adviser_order_list: [], // 顾问订单列表
  adviser_hasMore: false, // 顾问消息列表加载
  adviser_msg_isActive: 0 // 顾问消息激活状态
}

const actions = {
  loadAdviserList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'adviser_msg_list':
        url = `/adviser/v2/dialogue/records/${args.dialogueId}?pageIndex=${args.pageIndex}&pageSize=${args.pageSize}`
        break
      case 'adviser_order_list':
        url = `/adviser/v2/order?pageIndex=${args.pageIndex}&pageSize=${args.pageSize}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.newDytApiBaseApi
      .get(url)
      .then((res) => {
       res && res.status === 200
          ? (() => {
              commit({
                type: 'set_adviser_list',
                dataType: args.type,
                data: res.data,
                isActive: res.data.isActive,
                page: args.pageIndex
              })
            })()
          : commit({
              type: 'set_adviser_list',
              dataType: args.type,
              data: [],
              isActive: res.data.isActive,
              page: args.pageIndex
            })
        return Promise.resolve()
      })
      .catch((e) => {
        return Promise.loadAdviserList(e)
      })
  }
}

const getters = {}

const mutations = {
  // 设置列表
  set_adviser_list(state, args) {
    let data = args
    data.data = args.data.items
    data.data.length < 10 ? (state.adviser_hasMore = false) : (state.adviser_hasMore = true)
    if (data.dataType === 'adviser_msg_list') {
      state.adviser_msg_isActive = args.isActive
      if (args.page === 1) {
        if (data.data.length === 0) {
          state[args.dataType] = []
        } else {
          state[args.dataType] = data.data
        }
      } else {
        if (data.data.length !== 0) {
          state[args.dataType] = data.data.concat(state[args.dataType])
        }
      }
    } else {
      console.log(args)
      console.log(data)
      if (args.page === 1) {
        if (data.data.length === 0) {
          state[args.dataType] = []
        } else {
          state[args.dataType] = data.data
        }
      } else {
        if (data.data.length !== 0) {
          state[args.dataType].push(data.data)
        }
      }
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
